import { useOutletContext } from 'react-router-dom'

import { useEnhancedNavigate, useStableValue } from '../../../common/hooks'
import type { Tag } from '../../../common/types/common'
import { MainPathEnum } from '../../../common/types/routing'
import { compressAndEncodeJSON } from '../../../common/utils/jsonCompression'
import TimeLayout from '../TimeLayout'
import TimeStats from './TimeStats'

const Time = () => {
  const { tagFilters } = useOutletContext<{
    tagFilters: Tag[]
    appName: string
  }>()

  const { enhancedNavigate: navigate } = useEnhancedNavigate()

  const onNavigate = (tags: any) => {
    navigate(`/${MainPathEnum.BUSINESS_APPS}/window/${compressAndEncodeJSON(tags)}`)
  }

  // Stabilize objects to prevent unnecessary re-renders
  const stableVariables = useStableValue({ tag_filters: tagFilters })
  const stableQueryOptions = useStableValue({
    tagsOfInterestSource: 'window' as const,
    variables: stableVariables,
  })
  const stableActivityOptions = useStableValue({
    tagsOfInterestSource: 'window' as const,
    tagFilters,
  })

  return (
    <div className='flex flex-col gap-3'>
      <TimeStats />

      <TimeLayout
        queryOptionsApplications={stableQueryOptions}
        queryOptionsActivities={stableActivityOptions}
        onNavigate={onNavigate}
      />
    </div>
  )
}

export default Time

